(function () {
	function featuredBlogSlider() {
		const sliders = document.querySelectorAll('.blog-slider');

		if (!sliders.length) return;

		sliders.forEach((slider) => {
			if (slider.dataset.swiperInitialized === 'true') return;

			const id = slider.dataset.id;
			const sliderLoop = slider.dataset.loop;
			const sliderLoopTrue = sliderLoop === 'true';

			new Swiper(`.blog-slider-${id}`, {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 20,

				navigation: {
					nextEl: `#shopify-section-${id} .slider-arrow-next`,
					prevEl: `#shopify-section-${id} .slider-arrow-prev`,
				},

				breakpoints: {
					750: {
						loop: sliderLoopTrue,
						slidesPerView: 2,
					},

					990: {
						loop: sliderLoopTrue,
						slidesPerView: 'auto',
					},

					1199: {
						loop: sliderLoopTrue,
						slidesPerView: 'auto',
						spaceBetween: 30,
					},
				},
			});

			slider.dataset.swiperInitialized = 'true';
		});
	}

	document.addEventListener(
		'DOMContentLoaded',
		featuredBlogSlider
	);

	document.addEventListener(
		'shopify:section:load',
		featuredBlogSlider
	);
})();